import React from "react";
import PropTypes from "prop-types";
import util from "./../../../../util";
import styled from "styled-components";

const AlphabeticalFilterNavigation = ({
    values,
    handleChange,
    className
}) => {
    const filterBy = [];

    if(values.length > 0){
        values.map(x => !filterBy.find(f => f == x.substring(0,1)) ? filterBy.push(x.substring(0,1)) : null);
    }

    const alph = util.getAlphabet(),
        _fb = alph.map((letter, index) => {
            if(values.length > 0){
                return (
                    (filterBy.find(f => f == letter)) ? <a href="#" name={letter} onClick={handleChange} key={index}>{letter}</a> : <div key={index}>{letter}</div>
                );
            } else {
                return (
                    <li key={index}><a href="#" name={letter} onClick={handleChange}>{letter}</a></li>
                );
            }
        });
    const buttons = [
        <li key="All"><a href="#" onClick={handleChange} name="All">All</a></li>,
        ..._fb
    ];

    return (
        <React.Fragment>
            <ul className={`letter-list list-inline d-flex my-4 ${className}`}>
                {buttons}
            </ul>
        </React.Fragment>
    );
};

AlphabeticalFilterNavigation.defaultProps = {
    className: "",
    values: []
};

AlphabeticalFilterNavigation.propTypes = {
    className: PropTypes.string,
    values: PropTypes.array,
    handleChange: PropTypes.func
};

export default styled(AlphabeticalFilterNavigation)`
    max-width: 100%;
    overflow-x: auto;
    li{
        padding: 0.5rem 1rem;
        border-right: 1px solid #ccc;
    }
`;